import { requestForApi } from "../../utils/httpUtil";

/**
 * 获取树木详情
 * @param id
 * @returns
 */
export async function getTreeById(id: string) {
  const res = await requestForApi(`/api/v1/open/ancients/${id}`);
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/**
 * 保存留言信息
 * @param data
 * @returns
 */
export async function saveMessage(data: {
  name: string;
  phone: string;
  remark: string;
  ancientId: string;
}) {
  const res = await requestForApi("/api/v1/open/messages", {
    data,
    method: "POST",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/**
 * 判断用户是否对该树进行了点赞
 * @param id
 * @param phone
 * @returns
 */
export async function isLike(id: string, phone: string) {
  const res = await requestForApi(`/api/v1/open/ancients/likes/${id}/${phone}`);
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/**
 * 用户点赞
 * @param data
 * @returns
 */
export async function doLike(data: {
  ancientId: string;
  // phone: string;
  // userName: string;
}) {
  const res = await requestForApi("/api/v1/open/ancients/likes", {
    data,
    method: "POST",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}
